import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import ComponentTransparentDetail from '../../components/component_transparent/ComponentTransparentDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  getComponentTransparent,
  editComponentTransparent,
} from '../../redux/component_transparent/component_actions';

class ComponentTransparentEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.componentDetail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.component !== nextProps.component) && nextProps.show) {
      this.props.getComponent(nextProps.component.id);
    }
  }

  onSaveHandler() {
    const editedComponent = this.componentDetail.getWrappedInstance().getWrappedInstance().getComponentData();
    this.props.editComponent({
      ...editedComponent,
      id: this.props.component.id,
    });
  }

  render() {
    const { isEditing, errorMessage, componentDetail, editComponent, getComponent, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit transparent component')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ComponentTransparentDetail
            component={componentDetail}
            ref={ref => (this.componentDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="component-transparent-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.material.transparent.errorMessage,
  isEditing: state.component.transparent.isEditing,
  componentDetail: props.component && state.component.transparent.components[props.component.id],
});

const mapDispatchToProps = dispatch => ({
  editComponent: component => defaultRejectHandler(dispatch(editComponentTransparent(component.id, component.name, component.heat_dissipation_id, component.description, component.image))),
  getComponent: id => dispatch(getComponentTransparent(id)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentTransparentEditModal)
);



// WEBPACK FOOTER //
// ./src/modal/component_transparent/ComponentTransparentEditModal.js